
import { ShieldAlert } from "lucide-react";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

interface UserAvatarProps {
  username: string;
  isAdmin: boolean;
  userCredits?: number;
}

export function UserAvatar({ username, isAdmin, userCredits }: UserAvatarProps) {
  // Get initials from username for avatar
  const getInitials = () => {
    if (!username) return "";
    return username.substring(0, 2).toUpperCase();
  };

  return (
    <div className="relative">
      <Avatar>
        <AvatarFallback>
          {isAdmin ? (
            <ShieldAlert className="h-5 w-5 text-red-500" />
          ) : (
            getInitials()
          )}
        </AvatarFallback>
      </Avatar>
      {!isAdmin && userCredits !== undefined && (
        <span className="absolute -top-2 -right-2 flex h-5 w-5 items-center justify-center rounded-full bg-primary text-[10px] text-primary-foreground font-medium">
          {userCredits}
        </span>
      )}
    </div>
  );
}
